import type {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from '@reduxjs/toolkit/query';
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const apiProd = 'https://klqxulghgd.execute-api.us-east-1.amazonaws.com/prod/api';
const nodeEnv = process.env.REACT_APP_NODE_ENV;
const API_BASE_URL = nodeEnv === undefined ? apiProd : process.env.REACT_APP_SLS_LOOPBACK_API;

// Create a wrapper around fetchBaseQuery
const customBaseQuery: BaseQueryFn<
  FetchArgs,
  unknown,
  FetchBaseQueryError,
  object,
  FetchBaseQueryMeta
> = async (args, api, extraOptions) => {
  // Get base query with our configuration
  const baseQuery = fetchBaseQuery({
    baseUrl: API_BASE_URL,
  });

  // Get state and token
  const state = api.getState() as AppRootStates;
  const token = state?.token?.authorization ?? null;

  // Add access_token as query param if available
  if (token && args.url) {
    // Convert params to object if it exists, or create new object
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const existingParams = (args.params as Record<string, any>) || {};
    // Only add token if not already present in params
    if (!('access_token' in existingParams)) {
      args.params = {
        ...existingParams,
        access_token: token,
      };
    }
  }

  // Forward to the original base query
  return baseQuery(args, api, extraOptions);
};

export default customBaseQuery;
